export default {
    namespaced: true,
    account_settings: {
      title: "account settings",
      mobile_app: {
        title: "mobile app",
        description: "You can link your mobile app with your account by scanning the QR code",
        timeout_with_minutes: "Valid for {minutes} minutes and {seconds} seconds",
        timeout_without_minutes: "Valid for {seconds} seconds",
      },
      appColors: {
        title: "App colors",
        description: "you can change the app theme here",
        updating: "Updating colors",
        success: "Colors successfully changed, reloading page...",
        main_dashboard: "Main Dashboard",
        components: "Components",
        images: "Images",
        success_delete: "Theme successfully deleted",
        confirm_delete: "Are you sure to delete the theme '%theme%'?",
        success_edit: "Theme successfully updated",
        success_create: "Theme successfully created",
        theme_builder_description: "select or customize your UI theme"
      }
    },
};
  